import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';

import { useTranslations } from '@lang';
import { ReduxFormInput } from '@common/components/FormElements/BlockInputField';
import { Spinner } from '@common/components/Spinner';
import { FormRow, FormSuccessMessage } from '@common/components/AuthLayout/Layout';
import { Button } from '@common/components';
import { required, validEmail } from '@utils/validators';
import { Link } from 'shared-routing';
import { Routes } from '@common/constants';

const SubmitButton = styled(Button)`
  margin-top: 15px;
`;

const validate = (values) => {
  const errors = {};

  errors.email = required(values.email) || validEmail(values.email);

  return errors;
};

const ForgottenPasswordForm = ({ handleSubmit, submitting, submitSucceeded }) => {
  const { t } = useTranslations();

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Spinner isActive={submitting} showDelayMessage />
      {!submitSucceeded && (
        <>
          <FormRow>
            <Field
              component={ReduxFormInput}
              name="email"
              label={t('forgottenPassword.emailLabel')}
            />
          </FormRow>
          <FormRow align="right" actionButtons>
            <Link route={Routes.SIGNIN}>
              <Button type="button" isNarrow isInverted disabled={submitting}>
                {t('forgottenPassword.backToLogin')}
              </Button>
            </Link>{' '}
            <SubmitButton type="submit" isNarrow disabled={submitting} isPrimary>
              {t('forgottenPassword.send')}
            </SubmitButton>
          </FormRow>
        </>
      )}
      {submitSucceeded && (
        <>
          <FormRow>
            <FormSuccessMessage>{t('forgottenPassword.successMessage')}</FormSuccessMessage>
          </FormRow>
          <FormRow align="right">
            <Link route={Routes.HOME}>
              <Button type="button" isNarrow isInverted disabled={submitting}>
                {t('forgottenPassword.backToHomepage')}
              </Button>
            </Link>
          </FormRow>
        </>
      )}
    </form>
  );
};

ForgottenPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'forgottenPasswordForm',
  validate,
  touchOnChange: true,
})(ForgottenPasswordForm);
